// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container {
  width: 250px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: #ffffff;
  box-shadow: 4px 0 15px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  z-index: 1001;

  overflow: hidden;   /* 🔥 IMPORTANT */
   background: linear-gradient(
    180deg,
    #ffffff 0%,
    #ffffff 60%,
    #fdf1f1 100%
  );
}

/* LOGO */
.sidebar-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 22px 20px;
  border-bottom: 1px solid #eee;
}

.sidebar-header img {
  width: 170px;
}

.sidebar-header h4 {
  font-size: 18px;
  font-weight: 700;
  color: #e53935;
}

/* MENU */
.menu-list {
  padding: 15px 10px;
  flex: 1 1;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  margin-bottom: 8px;
  border-radius: 12px;
  color: #555;
  font-size: 15px;
  text-decoration: none;
  transition: 0.25s ease;
}

.menu-icon {
  width: 22px;
  height: 22px;
}

/* HOVER */
.menu-item:hover {
  background: #fbecec;
  color: #e53935;
}

/* ACTIVE */
.menu-item.active {
  background: #e53935;
  color: #ffffff;
  font-weight: 600;
}

.menu-item.active img {
  filter: brightness(0) invert(1);
}

/* FOOTER */
.sidebar-footer {
  padding: 20px;
}
.logout-btn {
  width: 85%;
  margin: 0 auto 50px 30px;   /* pushes button up */
  background: #e53935;
  border: none;
  color: #fff;
  padding: 12px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  z-index: 2;
}


.logout-btn:hover {
  background: #d32f2f;
}
.sidebar-header,
.menu-list,
.sidebar-footer {
  position: relative;
  z-index: 2;
}
.sidebar-bg {
  position: absolute;
  bottom: -10px;          /* slightly below but visible */
  left: 40%;
  transform: translateX(-50%);
  width: 220px;           /* bigger earth */
  height: auto;
  opacity: 1.25;          /* soft like image 1 */
  pointer-events: none;
  z-index: 0;
}


`, "",{"version":3,"sources":["webpack://./src/Pages/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,aAAa;;EAEb,gBAAgB,IAAI,iBAAiB;GACpC;;;;;GAKA;AACH;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,wBAAwB,IAAI,qBAAqB;EACjD,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,mBAAmB;AACrB;AACA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa,WAAW,+BAA+B;EACvD,SAAS;EACT,2BAA2B;EAC3B,YAAY,YAAY,iBAAiB;EACzC,YAAY;EACZ,aAAa,WAAW,sBAAsB;EAC9C,oBAAoB;EACpB,UAAU;AACZ","sourcesContent":[".sidebar-container {\r\n  width: 250px;\r\n  height: 100vh;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  background: #ffffff;\r\n  box-shadow: 4px 0 15px rgba(0,0,0,0.08);\r\n  display: flex;\r\n  flex-direction: column;\r\n  z-index: 1001;\r\n\r\n  overflow: hidden;   /* 🔥 IMPORTANT */\r\n   background: linear-gradient(\r\n    180deg,\r\n    #ffffff 0%,\r\n    #ffffff 60%,\r\n    #fdf1f1 100%\r\n  );\r\n}\r\n\r\n/* LOGO */\r\n.sidebar-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 22px 20px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.sidebar-header img {\r\n  width: 170px;\r\n}\r\n\r\n.sidebar-header h4 {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #e53935;\r\n}\r\n\r\n/* MENU */\r\n.menu-list {\r\n  padding: 15px 10px;\r\n  flex: 1;\r\n}\r\n\r\n.menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 18px;\r\n  margin-bottom: 8px;\r\n  border-radius: 12px;\r\n  color: #555;\r\n  font-size: 15px;\r\n  text-decoration: none;\r\n  transition: 0.25s ease;\r\n}\r\n\r\n.menu-icon {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n/* HOVER */\r\n.menu-item:hover {\r\n  background: #fbecec;\r\n  color: #e53935;\r\n}\r\n\r\n/* ACTIVE */\r\n.menu-item.active {\r\n  background: #e53935;\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n}\r\n\r\n.menu-item.active img {\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n/* FOOTER */\r\n.sidebar-footer {\r\n  padding: 20px;\r\n}\r\n.logout-btn {\r\n  width: 85%;\r\n  margin: 0 auto 50px 30px;   /* pushes button up */\r\n  background: #e53935;\r\n  border: none;\r\n  color: #fff;\r\n  padding: 12px;\r\n  border-radius: 25px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n\r\n.logout-btn:hover {\r\n  background: #d32f2f;\r\n}\r\n.sidebar-header,\r\n.menu-list,\r\n.sidebar-footer {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n.sidebar-bg {\r\n  position: absolute;\r\n  bottom: -10px;          /* slightly below but visible */\r\n  left: 40%;\r\n  transform: translateX(-50%);\r\n  width: 220px;           /* bigger earth */\r\n  height: auto;\r\n  opacity: 1.25;          /* soft like image 1 */\r\n  pointer-events: none;\r\n  z-index: 0;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
